module.exports = __webpack_public_path__ + "media/centennial college - toolkit testimonials - video 3.42ed32dd.mp4";